module.exports = __webpack_public_path__ + "img/17.c111d4bb.jpg";